var map = {
	"./amanda.png": "8ca5",
	"./andrew.png": "5682",
	"./justin.png": "a6c2",
	"./maciejc.png": "5c93",
	"./stephanie.png": "8e39",
	"./yogesh.png": "8294"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8627";